module.exports = __webpack_public_path__ + "img/456.5a2bc6d9.png";